export default "__VITE_ASSET__SXjj8QOa__"